const PROJECT_TYPE = 'ROCKY';

export const UPDATE_STATE_INFO =`${PROJECT_TYPE}_update_state_info`;
export const GET_EXPERIMENT = `${PROJECT_TYPE}_get_experiment`;
export const ADD_EXPERIMENT = `${PROJECT_TYPE}_add_experiment`;
export const UPDATE_EXPERIMENT_INFO = `${PROJECT_TYPE}_update_experiment_info`;
export const UPDATE_SINGLE_EXPERIMENT = `${PROJECT_TYPE}/update_single_experiment`;
export const UPDATE_EXPERIMENTS_STATUS = `${PROJECT_TYPE}/update_experiments_status`;

export const CLEAR_SWEEP_INFO = `${PROJECT_TYPE}_clear_sweep_info`;
export const UPDATE_SWEEP_CREATE_STATUS = `${PROJECT_TYPE}_update_sweep_create_status`;
export const UPDATE_ADD_LOADING = `${PROJECT_TYPE}_update_add_loading`;